// Feature flags
export const ENABLE_JO_REGISTRY = true;
